import * as COLOR from 'constant/color'
import * as NUMBER from 'constant/number'
import React, { useState } from 'react'
import { Modal, List, Tabs, Col, Row, Checkbox } from 'antd'
import PropTypes from 'prop-types'
import styles from './index.scss'

const { TabPane } = Tabs

const CookieModal = ({ showCookieModal, handleCancel, handleOk }) => {
  const [location, setLocation] = useState(false)
  return (
    <Modal
      bodyStyle={{
        backgroundColor: COLOR.GREY
      }}
      cancelText={'Close'}
      okText={'Save'}
      onCancel={handleCancel}
      onOk={() => handleOk(location)}
      title='Cookies Settings'
      visible={showCookieModal}
      width={700}
    >
      <p>Non-essential cookies help us improve the functionality of our website by collecting information and reporting on your use of the website as well as improving your user experience. You can manage and withdraw your content of non-essential cookies below.</p><br />
      {getTabs(setLocation)}

    </Modal>
  )
}

const getTabs = (setLocation) => (
  <Tabs
    defaultActiveKey={NUMBER.ONE}
    tabBarStyle={{ backgroundColor: '#fff', margin: '0', 'padding-bottom': '0' }}
    type='card'
  >
    <TabPane
      className={styles.tab_pane}
      key={NUMBER.ONE}
      tab='PURPOSES'
    >
      <List itemLayout='vertical'>
        <List.Item>
          <Row>
            <Col span={8}>
                  Location
            </Col>
            <Col
              offset={12}
              span={4}
            >
              <Checkbox onChange={(checked) => setLocation(checked.target.checked)}>Rejected</Checkbox>
            </Col>
          </Row>
        </List.Item>
      </List>
    </TabPane>
  </Tabs>
)
CookieModal.propTypes = {
  handleCancel: PropTypes.func,
  handleOk: PropTypes.func,
  showCookieModal: PropTypes.bool
}
export default CookieModal
